<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-6 col-sm-6 col-md-3 col-lg-3 col-xl-3">
          <c-plant type="none" name="plantCd" v-model="searchParam.plantCd" />
        </div>
      </template>
    </c-search-box>
    <c-table
      ref="table"
      title="체크리스트 항목"
      :columns="grid.columns"
      :data="grid.data"
      :gridHeight="grid.height"
      :editable="editable"
      :isExcelDown="false"
      :usePaging="false"
      selection="multiple"
      rowKey="checklistMasterId"
      @changeSelection="changeSelection"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline >
          <c-btn label="검색" icon="search" @btnClicked="getList" />
          <c-btn label="선택" icon="check" @btnClicked="select" />
        </q-btn-group>
      </template>
    </c-table>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'ctoChecklistMasterPop',
  props: {
    popupParam: {
      type: Object,
      default: function() {
        return {
          plantCd: '',
        }
      },
    },
    contentHeight: {
      type: [String, Number],
      default: function() {
        return 'auto'
      },
    }
  },
  data() {
    return {
      searchParam: {
        plantCd: null,
        useFlag: 'Y',
      },
      grid: {
        columns: [
          {
            name: 'checklistNamePrint',
            field: 'checklistNamePrint',
            label: '항목명',
            align: 'left',
            sortable: false,
            type: 'html'
          },
        ],
        height: '500px',
        data: [],
      },
      editable: true,
      listUrl: '',
    };
  },
  computed: {
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.sop.cto.stdchecklist.hierarchy.url
      // code setting
      if (this.popupParam.plantCd) {
        this.$set(this.searchParam, 'plantCd', this.popupParam.plantCd)
      }
      // list setting
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    changeSelection(detail) {
      if (detail.added) {
        let pushItems = [];
        this.$_.forEach(detail.rows, row => {
          // 부모가 추가된 경우
          if (row.parentChecklistMasterId === '0000000000') {
            pushItems = this.$_.concat(pushItems, this.$_.filter(this.grid.data, filterItem => {
              return filterItem.parentChecklistMasterId === row.checklistMasterId
                && this.$_.findIndex(this.$refs['table'].selected, { checklistMasterId: filterItem.checklistMasterId }) === -1
            }))
          }
        })
        setTimeout(() => {
          this.$refs['table'].selected = this.$_.concat(this.$refs['table'].selected, pushItems)
        }, 100);
      } else {
        this.$_.forEach(detail.rows, row => {
          // 부모가 해제된 경우
          if (row.parentChecklistMasterId === '0000000000') {
            let childItems = this.$_.filter(this.grid.data, filterItem => {
              return filterItem.parentChecklistMasterId === row.checklistMasterId
                && this.$_.findIndex(this.$refs['table'].selected, { checklistMasterId: filterItem.checklistMasterId }) > -1
            })
            this.$_.forEach(childItems, item => {
              this.$refs['table'].selected.splice(
                this.$_.findIndex(this.$refs['table'].selected, { checklistMasterId: item.checklistMasterId }),
                1
              )
            })
          }
        })
      }
    },
    select() {
      let selectData = this.$refs['table'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '선택된 항목이 없습니다.', // 선택된 항목이 없습니다.
          type: 'warning', // success / info / warning / error
        });
      } else {
        this.$emit('closePopup', selectData);
      }
    },
  }
};
</script>
